import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo(title, description) {
  useEffect(() => {
    const full = title ? `${title} | MA LEBA` : "Ma Leba — ONG & Association MA LEBA";
    const desc = description || "Soigner, nourrir, former : ensemble pour l'avenir de son prochain.";
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", `${window.location.origin}/assets/ma-leba.jpg`);
    setMeta("property", "og:url", window.location.href);
  }, [title, description]);
}
